import { useQuery } from "@tanstack/react-query";

import QueryData from "Constants/QueryData";
import { ISurvey } from "Types/survey";

import { useAppSelector } from "Hooks/useRedux";

import Api from "Api";
import { MAP_CENTER } from "Constants/App";

export default function useSurveys() {
  const { status } = useAppSelector((state) => state.menu);
  const { visible, type } = useAppSelector((state) => state.surveys);
  const { source, destination, autoApply, applySelecteds, forceUpdate, zone } = useAppSelector((state) => state.zones);
  const { conformity, surveys } = useAppSelector((state) => state.filters);
  const { center, moveEnd } = useAppSelector((state) => state.map);

  const filterQueries = () => {
    let result = "";
    Object.keys(surveys).forEach((i) => {
      const value = surveys[i as keyof typeof surveys];
      if (value !== "" && i !== "working_days") result += `&${i}=${value}`;
    });
    return result;
  };
  const workingDaysQuery = () => {
    if (!surveys.working_days) return "";

    let result = "";
    surveys.working_days.forEach((i: number) => {
      result += `&working_days[]=${i}`;
    });
    return result;
  };
  const conformityQuery = () => {
    return `${conformity.source ? "&contain[]=sources" : ""}${conformity.destination ? "&contain[]=destinations" : ""}`;
  };
  const zonesQuery = () => {
    if (source.length === 0 && destination.length === 0) {
      return `&center_lat=${center.lat}&center_lng=${center.lng}&radius=1`;
    }
    return `${source.length > 0 ? `&${source.map((i) => `source_zones[]=${i}`).join("&")}` : ""}${
      destination.length > 0 ? `&${destination.map((i) => `destination_zones[]=${i}`).join("&")}` : ""
    }`;
  };

  const handleQueryKeys = () => {
    if (autoApply) {
      return [QueryData.SURVEY.key, conformity, source, destination, moveEnd, type];
    }
    return [QueryData.SURVEY.key, conformity, forceUpdate, moveEnd, type];
  };
  const { data, isLoading, refetch, isFetching } = useQuery({
    queryKey: handleQueryKeys(),
    queryFn: (): Promise<ISurvey[]> => {
      return Api.get(
        `${QueryData.SURVEY.url}${conformityQuery()}${zonesQuery()}${filterQueries()}${workingDaysQuery()}&input=${type}`
      ).then((res) => {
        return res.data.Data.data;
      });
    },
    enabled: visible || status === "survey",
  });

  return { data, isLoading, refetch, isFetching };
}

// ${conformityQuery()}${zonesQuery()}${filterQueries()}${workingDaysQuery()}&created_after=2023-09-23 11:15:00
